import { HotelImage } from "./HotelImage"
import React, { createContext } from "react"
import { gallery } from "./gallery"
import "./input.css"
import { quickCallButton } from "./quickCallButton"
import { RoomCard } from "./roomCard"
import { rooms } from "./rooms"
import { termAndCondition } from "./termAndCondition"
import { text } from "./text"
import { contact } from "./contact"
import Facebook from "@mui/icons-material/Facebook"
export const lineLink = "https://lin.ee/CX19xsM"
export interface textLang {
  th: string
  en: string
}
export const telIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
    />
  </svg>
)
interface MyState {
  lang: "TH" | "EN"
}
export const LangContext = createContext("EN")
interface MyProps {}
class App extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props)
    this.state = {
      lang: "EN",
    }
  }
  render() {
    const changeLangButton = () => {
      const getBG = (lang: "TH" | "EN") => {
        if (this.state.lang === lang) return "bg-olive text-white"
      }

      return (
        <div className="absolute right-0 z-10 rounded-bl-xl bg-cream text-lg text-olive">
          <button
            className={`min-h-[44px] min-w-[44px] rounded-b-2xl px-3 ${getBG("TH")}`}
            onClick={() => this.setState({ lang: "TH" })}
          >
            TH
          </button>
          <button
            className={`min-h-[44px] min-w-[44px] rounded-b-2xl px-3 ${getBG("EN")}`}
            onClick={() => this.setState({ lang: "EN" })}
          >
            EN
          </button>
        </div>
      )
    }
    return (
      <div className="bg-secondary pb-[calc(4rem+env(safe-area-inset-bottom))] lg:pb-0">
        <LangContext.Provider value={this.state.lang}>
          <div className=" relative font-poppins  container mx-auto shadow-2xl bg-cover ">
            {quickCallButton()}
            {changeLangButton()}
            <div className="">
              <div
                className={`hotel-hero bg-primary
                min-h-[320px] h-[50svh] sm:min-h-[400px] lg:h-[70vh]
                flex items-center justify-center
                bg-center lg:bg-bottom
                bg-cover
                lg:bg-fixed
                bg-no-repeat
                `}

              >
                <div
                  className="w-full text-center"
                >
                  <img alt="Nan Lamoon Hotel" src="white-logo.png" className="mx-auto w-64 max-w-[75%] sm:w-80 lg:w-96" />
                </div>
              </div>
            </div>

            <div className="container  mx-auto text-center border-spacing-4 ">
              <h1 className="text-3xl  text-olive p-6 bg-soft-primary">
                {text({
                  en: "In the middle of Nan city",
                  th: "อยู่ใจกลางเมืองน่าน",
                })}
              </h1>
            </div>

            <div className="grid sm:grid-cols-2 bg-primary">
              <div>
                <HotelImage alt="Nan Lamoon Hotel exterior" src="images/DSC_0303 Large.jpeg" className="bg-cover" />
              </div>
              <div>
                <div className="text-ink p-6 lg:p-12 text-left    ">
                  {text({
                    th: "ยินดีต้อนรับสู่โรงแรมน่านละมุน สถานที่ที่มีความเรียบง่าย ตั้งอยู่ใจกลางเมืองน่าน ล้อมรอบด้วยเฉดสีเขียวของน่านที่มีชีวิตชีวา สร้างบรรยากาศที่เติมเต็มการพักผ่อนของคุณได้อย่างลงตัว โรงแรมของเราตั้งอยู่ใกล้ถนนคนเดินใจกลางเมืองน่าน",
                    en: "Welcome to Nan Lamoon Hotel, a place that simplicity . Located in the heart of Nan City, surrounded by the vibrant hues of Nan green, it creates an atmosphere that perfectly complements your relaxation. Our hotel is conveniently near the walking street, right in the center of Nan City",
                  })}
                </div>
              </div>
            </div>

            {/* <div
              className={`hotel-hero bg-primary
                lg:h-[70vh] sm:h-[50vh] h-[50vh]
                flex items-center justify-center
                lg:bg-bottom bg-bottom
                bg-cover lg:bg-contain
                lg:bg-fixed
                bg-no-repeat
                `}
              style={{
                backgroundImage: "url('./images/IMG_7555-2 Large.jpeg')",
                // backgroundImage: "url('./white-logo.png')",
              }}
            >
              <div className="text-center m-auto text-olive text-6xl"></div>
            </div> */}

            <div className="bg-secondary  p-5  w-full">
              <div className="text-3xl text-center text-olive p-6">
                {text({ th: "ห้องพัก", en: "Our Room" })}{" "}
              </div>
              <div className="grid auto-rows-fr grid-cols-1 gap-6 text-center md:grid-cols-2 lg:grid-cols-3">
                {rooms.map((room) => (
                  <RoomCard key={room.id} {...room} />
                ))}
              </div>
            </div>

            <div className="grid sm:grid-cols-2 bg-soft-primary">
              <div>
                <div className="text-olive text-2xl lg:text-4xl  ">
                  <div className="flex  items-center justify-center  relative ">
                    <div className="absolute text-center whitespace-pre-line px-4  z-10">
                      {text({
                        th: "ที่จอดรถเพียงพอ\nสำหรับทุกห้อง",
                        en: "Convenient Parking",
                      })}
                      <br />
                      <div className="border-soft-primary text-4xl">
                        <a
                          target="_blank" rel="noopener noreferrer"
                          href="https://www.facebook.com/reel/336744589078202"
                          aria-label="Watch the hotel parking video"
                          className="hover:text-ink"
                        >
                          <Facebook style={{ zoom: "250%" }} />
                        </a>
                      </div>
                    </div>

                    <div className="relative z-0 ">
                      <HotelImage
                        alt=""
                        aria-hidden="true"
                        style={{
                          opacity: 0,
                          width: "100%",
                          zIndex: -1,
                        }}
                        src="images/IMG_7555-2 Large.jpeg"
                        className="bg-cover "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <HotelImage alt="Hotel parking area" src="images/IMG_7555-2 Large.jpeg" className="bg-cover" />
              </div>
            </div>

            {termAndCondition()}

            {contact()}
            <div className="bg-primary text-olive ">
              <div className="text-3xl text-center p-6">
                {text({ en: "Map", th: "แผนที่" })}
              </div>
              <div className=" text-center">
                <div className=" bg-white min-w-full ">
                  <HotelImage sizes="100vw" alt="Map showing the location of Nan Lamoon Hotel" src="map2.png" />
                  <div className="text-center text-muted pb-4 text-lg">
                    {text({
                      en: "10/8 Nai Wiang, Mueang Nan District, Nan 55000",
                      th: "10/8 ตำบลในเวียง อำเภอเมือง จังหวัดน่าน 55000",
                    })}
                  </div>
                </div>
                <div className="bg-soft-primary p-12 rounded-xl w-full">
                  <p className="inline align-middle p-2 m-auto">
                    <a
                      className="text-2xl"
                      target="_blank" rel="noopener noreferrer"
                      href="https://www.google.com/maps/place/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B9%81%E0%B8%A3%E0%B8%A1%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B8%A5%E0%B8%B0%E0%B8%A1%E0%B8%B8%E0%B8%99/@18.7718215,100.7692255,17z/data=!3m1!4b1!4m9!3m8!1s0x31278f62de6122eb:0xac312e98aa871d03!5m2!4m1!1i2!8m2!3d18.7718215!4d100.7692255!16s%2Fg%2F11vkbtbprv?entry=ttu"
                    >
                      <img alt="" src="google-map.svg" className="h-32 m-auto" />
                      <br />
                      {text({
                        en: "Open in Google Map",
                        th: "เปิดใน Google Map",
                      })}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {gallery()}
          </div>
          {PageFooter()}
        </LangContext.Provider>
      </div>
    )
  }
}
export default App

export function PageFooter() {
  return (
    <div className="bg-primary  text-ink text-center px-6 py-12 md:p-16 text-lg">
      <div>
        {text({
          en: "10/8 Nai Wiang, Mueang Nan District, Nan 55000",
          th: "10/8 ตำบลในเวียง อำเภอเมือง จังหวัดน่าน 55000",
        })}
      </div>
    </div>
  )
}
